import React from "react";
import html2canvas from "html2canvas";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { jsPDF } from "jspdf";
import { Grid, Typography } from "@mui/material";
import { AddCircleOutline as AddCircleOutlineIcon } from "@mui/icons-material";
import { Search as SearchIcon } from "react-feather";

import useAuth from "../../hooks/useAuth";
import useZone from "../../hooks/user/useZone";
import { formatDate } from "../../utils/format";
import { UserType } from "../../utils/constants";

import ZoneTable from "../../components/pages/llm/zones/T_Zone";
import { Button, Input, Search, SearchIconWrapper, SnackbarAlert } from "../../components/pages/common/styled";

function Zones() {
  const navigate = useNavigate();
  const {
    isAuthenticated,
    homeController,
    wafdashController,
    websiteController,
    zoneController,
    wafeventController,
    planController,
    setZoneController,
    userType,
  } = useAuth();
  const { zones, getZones, getZonesForList, errMsg, setErr } = useZone();
  const [pattern, setPattern] = React.useState("");

  const [snackOpen, setSnackOpen] = React.useState(false);
  const [message, setMessage] = React.useState();
  const [success, setSuccess] = React.useState();
  const handleSnackClose = () => {
    setSnackOpen(false);
    setErr(null);
  };

  React.useEffect(() => {
    if (errMsg) {
      setSnackOpen(true);
      setMessage(errMsg);
      setSuccess("error");
    } else {
      setSnackOpen(false);
      setMessage(null);
    }
  }, [errMsg]);
  React.useEffect(() => {
    window.scrollTo(0, 0);
    if (isAuthenticated) {
      if (homeController) homeController.abort();
      if (wafdashController) wafdashController.abort();
      if (websiteController) websiteController.abort();
      if (zoneController) zoneController.abort();
      if (wafeventController) wafeventController.abort();
      if (planController) planController.abort();
      getZonesForList();
      getZones(setZoneController);
    }
    return () => setErr(null);
  }, [isAuthenticated]); // eslint-disable-line react-hooks/exhaustive-deps

  const gotoAddNewZone = () => {
    navigate("/llm/zones/new");
  };

  const downloadZones = () => {
    var curDate = new Date();
    const input = document.getElementsByClassName("MuiTableContainer-root")[0];
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF({
        orientation: input.offsetWidth > input.offsetHeight ? "l" : "p",
        unit: "px",
        format: [input.offsetWidth + 240, input.offsetHeight + 180],
      });
      pdf.addImage(imgData, "JPEG", 120, 90, input.offsetWidth, input.offsetHeight);
      pdf.save(`SD_Zones (` + formatDate(curDate) + `).pdf`);
    });
  };
  const refresh = async () => {
    window.scrollTo(0, 0);
    if (isAuthenticated) {
      if (homeController) homeController.abort();
      if (wafdashController) wafdashController.abort();
      if (websiteController) websiteController.abort();
      if (zoneController) zoneController.abort();
      if (wafeventController) wafeventController.abort();
      if (planController) planController.abort();
      getZonesForList();
      getZones(setZoneController);
    }
  };
  return (
    <>
      <Helmet title="Zones" />
      <Grid container sx={{ display: "flex", alignItems: "center", marginTop: "38px" }}>
        <Grid item>
          <Typography variant="h1" display="inline">
            Zones
          </Typography>
        </Grid>
        <Grid item xs></Grid>
        <Grid item alignItems="right" display="flex">
          <Search style={{ border: "none", background: "white" }}>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <Input
              placeholder="Search zone"
              value={pattern}
              onChange={(event) => {
                setPattern(event.target.value);
              }}
            />
          </Search>
          {UserType.ORG_USER === userType ? (
            <></>
          ) : (
            <Button
              variant="contained"
              color="primary"
              ml={2}
              onClick={gotoAddNewZone}
              startIcon={<AddCircleOutlineIcon />}
              disabled={null === zones}
            >
              Add Zone
            </Button>
          )}
        </Grid>
      </Grid>

      <Grid container spacing={6}>
        <Grid item xs={12} md={12}>
          <ZoneTable pattern={pattern} refresh={refresh} downloadZones={downloadZones} />
        </Grid>
      </Grid>
      <SnackbarAlert open={snackOpen} onClose={handleSnackClose} severity={success} message={message} />
    </>
  );
}

export default Zones;
